import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-campaign-hub",
    templateUrl: "./campaign-hub.component.html",
    standalone: false
})
export class CampaignHubComponent implements OnInit {
  private readonly campaignHubUrl = `${environment.links.blog}campaign-hub`;

  constructor() {}

  ngOnInit(): void {
    if (this.campaignHubUrl) {
      window.location.href = this.campaignHubUrl;
    } else {
      console.error("Campaign Hub URL is not defined.");
    }
  }
}
